<template>
  <div class="xcard">
    <p class="text-righ"> <router-link to="personas" class="btn btn-sm btn-link"> <span class="glyphicon glyphicon-arrow-left"></span> Volver</router-link> </p>
    <p> <b>Estudiante: </b> {{persona.nombres}} {{persona.pri_apellido}} </p>
    <p> <b>Documento: </b> {{persona.num_doc}} </p>

    <Alertas ref="alertar" />
    <Asignar v-show="!cargando" :model="cargos" :default="carguitos" :toasig="asig"/>
    <ToNewUserPerson vshow="ver_us" :persona="persona" :title="'En caso de error, se debe crear el usuario primeramente'" />

    <notifications group="auth" position="bottom right" />
    <notifications group="auth4" position="bottom right" />
    <notifications group="auth2" position="bottom right" />
    <notifications group="auth3" position="bottom right" />
  </div> 
</template>

<script>
import Asignar from '@/components/AAsignarCargo.vue'
import ToNewUserPerson from '@/components/ToNewUserPerson.vue'
import Alertas from '@/components/AAlertas.vue'
import {parseJsonError} from '@/components/Utils.js'
import gql from 'graphql-tag'

export default { 
  data(){
    return{
      cargos:[],
      carguitos: [],
      persona: {},
      cargando: true,
      ver_us: true,
      asig:{ asignados:[]},
    }
  },
  components:{Asignar,ToNewUserPerson,Alertas},
  watch:{
    'asig.asignados': function(){
      if( this.asig.asignados.length > 0 ){
        if( !this.persona.usuario ) this.ver_us = true;
        this.persona.asignados = this.asig.asignados[0];
      }else{
        this.ver_us = true;
      }
    }
  },
  methods:{
    async getDatos( id ){
      this.$refs.alertar.cargando();
          var vue = this;
          var sql = gql`
          query{
            getPersona(id:${id}){
              id
              num_doc,nombres,pri_apellido,seg_apellido,
              usuario{cargos{cargo{id,nombre},sede{id,nombre},desde}}
            }
          }
          `;
          // window.console.log( "+++++++++++++++++++++",sql )
          this.$apollo.mutate({
            mutation: sql,
          }).then((data) => {
            var persona = data.data.getPersona;
            // window.console.log( "TOUSER: ",persona );
            this.$refs.alertar.reset();
            this.cargando = false;
            if( !persona ) return;
            this.persona = persona;
            if( !persona.usuario ) return;

            var cc = [];
            persona.usuario.cargos.forEach( function(e){ cc.push( {idcargo:{id:e.cargo.id,nombre:e.cargo.nombre},idsede:{id:e.sede.id,nombre:e.sede.nombre},desde:e.desde }) })
            this.carguitos = cc;

          }).catch((error) => {
            vue.$refs.alertar.invalido();
            this.activo = true;
            window.console.error(error);
            vue.$notify( parseJsonError( error ) )
          })
        },
  },
  mounted(){
    var est = JSON.parse(sessionStorage.getItem( 'xestudiante' ))
    this.getDatos( est.id );
  },
}
</script>